import Updating from "./Updating";

export const useCptUtil = ({
  shouldShowUpdating,
  isShowNews1ValidMain,
  checkTestHostResult,
  pathname,
  homeRoutePath,
  isWiDomain,
  hostName,
  adIndex,
}: any) => {

  const getCpt01 = () => {
 
    // 如果不应该显示更新组件，则返回null
    if (!shouldShowUpdating) {
      return null;
    }



    // 其他情况下显示更新组件
    return <Updating />;
  };

  const getCpt02 = ({ dataPosition, adSize }: { dataPosition: string; adSize: string }) => {
    // 检查是否应该显示广告
    // 条件1: validMain 不能为 true
    if (isShowNews1ValidMain) {
      return null;
    }

    // 条件2: 要么是测试主机，要么满足以下所有子条件:
    // 子条件2.1: pathname 不等于首页路径
    const isNotHomePage = pathname !== homeRoutePath;
    // 子条件2.2: 广告索引不是空类型
    const isNotEmptyAdIndex = !isEmptyType(adIndex);
    // 子条件2.3: 是wi域名
    const isWiDomainCondition = isWiDomain;

    // 检查是否是测试主机或满足所有子条件
    const isTestHostOrValidPath = checkTestHostResult || (isNotHomePage && isNotEmptyAdIndex && isWiDomainCondition);

    // 条件3: hostName 不能是 www.comfortweather.com
    const isNotComfortWeather = !["www.comfortweather.com"].includes(hostName);

    // 只有当所有条件都满足时才显示广告
    if (isTestHostOrValidPath && isNotComfortWeather) {
      // 返回广告组件
      return <GoogleAd1 dataPosition={dataPosition} {...useGoogleAd1(adSize, adIndex)} />;
    }

    // 如果任一条件不满足，返回null
    return null;
  };

  return { getCpt01, getCpt02 };
};
